import { render, staticRenderFns } from "./add-surcharge-list.vue?vue&type=template&id=1594b744&"
import script from "./add-surcharge-list.vue?vue&type=script&lang=js&"
export * from "./add-surcharge-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports